// extracted by mini-css-extract-plugin
module.exports = {"options-wrapper":"FrequencyOptions_options-wrapper__HW1s7","options-label":"FrequencyOptions_options-label__7npr7"};